// extracted by mini-css-extract-plugin
export default {"indicator-bar":"_4gloEcO","indicator-bar__progress":"Ihmg2Qs","indicator-bar__triangle":"OzK2pYI"};